import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import SuppliersHotel from "../components/suppliers-hotel";

const ApiHotelIntegration = () => {
  return (
    <div>
      <PageHeader page="hotel-api-integration" />
      <div className="container">
        <div className="text-center">
          <p>
            85+ suppliers integrated—we manage integration complexity for you. Enterprise integration options: managed service (we handle it), custom connectors (built to your spec), or API-first architecture (extend without replacement). Deep relationships with global hotel chains and independent properties mean ongoing support, not just one-time integration.
          </p>

          <SuppliersHotel />
        </div>
      </div>
    </div>
  );
};

export default ApiHotelIntegration;
